var _line, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeRange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 10,
    viewBox: "0 0 110 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.09766,
    y1: 4.5,
    x2: 106.7,
    y2: 4.49999,
    stroke: "#133F7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 5,
    r: 5,
    transform: "rotate(-90 105 5)",
    fill: "#FF822E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "rotate(-90 5 5)",
    fill: "#133F7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeRange);
export default __webpack_public_path__ + "static/media/time-range.f9f85c845b465ef81a598c0833d4e775.svg";
export { ForwardRef as ReactComponent };